module.exports = "<div class=\"editorUi-row editorUi-loadingDroplet\">\n  <div class=\"drzLoader-wrapper\">\n    <div class=\"drzLoader-flex-wrapper\">\n      <div class=\"drzLoader-small\">\n        <div class=\"drzLoader-drop-1\"></div>\n        <div class=\"drzLoader-drop-2\"></div>\n        <div class=\"drzLoader-drop-3\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/_bubble-options/components/loading-droplet/template.html
// module id = Mab3
// module chunks = 0